<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <EditForm :defaultValues="{ type: 1 }" create title="Create proxy" @finish="handleItemsUpdate">
              <template #button="{ onclick }">
                <b-button type="button" variant="success" @click="onclick"><i class="fas fa-plus"></i> Create</b-button>
              </template>
            </EditForm>
          </div>
        </div>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="scroll-wrapper">
                <div class="scroll">
                </div>
              </div>
              <div class="table-wrapper mb-10">
                <b-table :striped="true" :small="true" :hover="true" :empty-text="emptyText" show-empty :busy="!!cancel"
                  :items="items" :fields="fields" :no-local-sorting="true" :sort-icon-left="true"
                  @sort-changed="sortingChanged">
                  <template #cell(actions)="row">
                    <EditForm :defaultValues="{ ...row.item }" title="Edit proxy" @finish="handleItemsUpdate" />
                    <RemoveForm :object="row.item.proxyId" message="Please confirm removing proxy"
                      :url="'/api/v1/proxies/' + row.item.proxyId" @finish="handleItemsUpdate" />
                  </template>
                </b-table>
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <b-pagination class="float-right" v-model="pagination.page" :total-rows="pagination.records"
                  :per-page="pagination.onPage" @change="onPageChange" first-number last-number />
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <ve-pagination class="float-right" :page-index="pagination.page" :page-size="pagination.onPage"
                  :total="pagination.records" :pagingCount="pagination.count" :layout="['total', 'sizer']"
                  :pageSizeOption="pagination.pageSizeOption" @on-page-size-change="onPageSizeChange" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import EditProxyForm from "../../components/Proxy/EditProxyForm.vue";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";
import axios from "axios";
import { getRouteIcon, ROUTE_PROXY } from "../../utils/routerIcons";

function getDefaultPagination() {
  return {
    onPage: 25,
    page: 1,
    records: 0,
    count: 5,
    pageSizeOption: [25, 50, 100, 200],
  };
}

export default {
  components: {
    EditForm: EditProxyForm,
    RemoveForm,
  },
  data() {
    return {
      cancel: null,
      error: null,
      fields: [
        { key: 'id', label: '_ID', sortable: true, },
        { key: 'proxyId', label: 'Proxy ID', sortable: true, },
        { key: 'source', label: 'Source', },
        { key: 'type', label: 'Type', },
        { key: 'actions', label: 'Actions', }
      ],
      sortBy: null,
      sortDesc: null,
      items: [],
      filters: {},
      pagination: getDefaultPagination(),
    }
  },
  computed: {
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error) {
        return this.error;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_PROXY),
  },
  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.pagination.page = 1;

      this.loadItems();
    },
    handleItemsUpdate() {
      this.loadItems();
    },
    loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });

      this.items = [];

      this.startedAt = new Date();
      this.finishedAt = null;

      let self = this;
      loadingInstance.show();

      this
        .$http({
          url: '/api/v1/proxies',
          params: {
            // pagination
            limit: this.pagination.onPage,
            offset: this.pagination.onPage * (this.pagination.page - 1),

            // sort params
            orderBy: this.sortBy,
            direction: this.sortDesc ? 'DESC' : 'ASC',
          },
          method: 'GET',
          cancelToken: new axios.CancelToken(c => { self.cancel = c }),
        })
        .then(resp => {
          let { items, pagination: { limit, totalCount } } = resp.data;

          this.items = items;
          this.pagination.onPage = limit;
          this.pagination.records = totalCount;
        })
        .catch((err) => {
          this.items = [];
          this.error = err;
        })
        .finally(() => {
          loadingInstance.close();
          this.cancel = null;
        });
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.loadItems()
    },
    onPageSizeChange(pageSize) {
      this.pagination.page = 1;
      this.pagination.onPage = pageSize;
      this.loadItems();
    },
    onFinishEdit() {
      this.loadItems();
    },
  },
  mounted() {
    this.loadItems();
  }
}
</script>
